/* ACORN GOLF — sign configurator behaviour (09/10/2026). Gallery, tabs, accordion steps, live selection summary, variant matching (product pages) and WhatsApp link. */
(function () {
  function init(root) {
    if (!root || root.__acfg) return;
    root.__acfg = true;

    var scope = root.closest('.shopify-section') || document;
    var steps = [].slice.call(root.querySelectorAll('.acfg__step[data-field]'));
    var thumbs = [].slice.call(root.querySelectorAll('.acfg__thumb'));
    var main = root.querySelector('[data-acfg-main]');
    var summaryEl = root.querySelector('[data-acfg-summary]');
    var selEl = root.querySelector('[data-acfg-selection]');
    var skuEl = root.querySelector('[data-acfg-sku]');
    var wa = root.querySelector('[data-acfg-wa]');
    var dataEl = scope.querySelector('[data-acfg-variants]');
    var data = null;
    try { data = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { data = null; }
    var current = 0;

    function show(i) {
      if (!main || !thumbs.length) return;
      if (i < 0) i = thumbs.length - 1;
      if (i >= thumbs.length) i = 0;
      current = i;
      var t = thumbs[i];
      var img = main.querySelector('img');
      if (!img) { img = document.createElement('img'); main.insertBefore(img, main.firstChild); }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = t.getAttribute('data-full');
      img.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = root.querySelector('[data-acfg-prev]');
    var next = root.querySelector('[data-acfg-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    /* ---------- Accordion steps: one open at a time ---------- */
    function setOpen(step, open) {
      var head = step.querySelector('.acfg__head');
      var body = step.querySelector('.acfg__body');
      if (!head || !body) return;
      step.classList.toggle('is-open', open);
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
    }
    function advance(step) {
      /* Closes this step and opens the next one */
      var i = steps.indexOf(step);
      setOpen(step, false);
      if (i > -1 && steps[i + 1]) setOpen(steps[i + 1], true);
    }
    steps.forEach(function (step) {
      var head = step.querySelector('.acfg__head');
      if (!head) return;
      head.addEventListener('click', function () {
        var willOpen = !step.classList.contains('is-open');
        steps.forEach(function (s) { setOpen(s, false); });
        if (willOpen) setOpen(step, true);
      });
    });

    function update() {
      var labels = [], values = [], byOpt = {};
      steps.forEach(function (s) {
        var c = s.querySelector('input:checked');
        if (!c) return;
        var name = c.getAttribute('data-name') || c.value;
        var field = s.getAttribute('data-field');
        /* Yes / No answers need their question in front to make sense */
        labels.push((name === 'Yes' || name === 'No') ? field + ': ' + name : name);
        values.push(field + ': ' + c.value);
        var hv = s.querySelector('[data-hval]');
        if (hv) hv.textContent = name;
        var o = s.getAttribute('data-option');
        if (o) {
          var p = s.getAttribute('data-part') || 'whole';
          byOpt[o] = byOpt[o] || {};
          byOpt[o][p] = name;
        }
      });
      var text = labels.join(' · ');
      if (summaryEl) summaryEl.textContent = text;
      if (selEl) selEl.value = values.join(', ');

      if (data && data.variants) {
        var target = data.options.map(function (n) {
          var b = byOpt[n];
          if (!b) return null;
          if (b.whole) return b.whole;
          return [b.first, b.second].filter(Boolean).join(' - ');
        });
        var match = null;
        data.variants.forEach(function (v) {
          if (match) return;
          var ok = v.options.every(function (o, i) { return target[i] === null || target[i] === o; });
          if (ok) match = v;
        });
        if (match) {
          if (skuEl) skuEl.value = match.sku || '';
          if (match.media) {
            for (var j = 0; j < thumbs.length; j++) {
              if (thumbs[j].getAttribute('data-media') === String(match.media)) { show(j); break; }
            }
          }
        }
      }

      if (wa) {
        var intro = wa.getAttribute('data-intro') || 'Hi Acorn Golf, I\'d like to enquire about this sign';
        var msg = intro + (text ? ' (' + text + ')' : '') + '. Could you let me know timings and price?';
        var base = wa.getAttribute('href').split('?text=')[0];
        wa.setAttribute('href', base + '?text=' + encodeURIComponent(msg));
      }
    }

    /* A different choice: update, then move on */
    root.addEventListener('change', function (e) {
      var step = e.target && e.target.closest && e.target.closest('.acfg__step');
      if (!step) return;
      update();
      advance(step);
    });
    /* The choice that is already picked (e.g. the pre-selected one): a click still moves on */
    root.addEventListener('pointerdown', function (e) {
      var input = e.target && e.target.closest && e.target.closest('.acfg__opt');
      input = input && input.querySelector('input');
      if (input) input.__was = input.checked;
    });
    root.addEventListener('click', function (e) {
      var lab = e.target && e.target.closest && e.target.closest('.acfg__opt');
      var input = lab && lab.querySelector('input');
      if (!input || e.target === input) return;
      var step = input.closest('.acfg__step');
      if (input.__was === true && input.checked && step && step.classList.contains('is-open')) {
        input.__was = false;
        advance(step);
      }
    });

    var tabs = [].slice.call(root.querySelectorAll('.acfg__tab'));
    var panels = [].slice.call(root.querySelectorAll('.acfg__tabpanel'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panels.forEach(function (p, j) { if (j === i) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); });
      });
    });

    update();
  }

  function boot() { document.querySelectorAll('.acfg').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target && e.target.querySelector('.acfg')); });
})();
